// DS: i12.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioAnalytics: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M13.24 1c.43.05.76.41.76.85v12.3c0 .47-.38.85-.85.85H2.85a.85.85 0 0 1-.85-.85V1.76c.05-.43.41-.76.85-.76zM3.7 13.3h8.6V2.7H3.7zm6.5-8.43c.32.01.59.22.67.53l.24.94.02.14a.7.7 0 0 1-1.03.65L8.96 9.09a.9.9 0 0 1-1.04.4l-.08-.02-.9-.36-1.02 1.67-.09.11a.7.7 0 0 1-1.1-.85l1.25-2.02.1-.13a.9.9 0 0 1 .85-.28l.15.05.88.35.93-1.6A.7.7 0 0 1 9 5.06l1.09-.18h.13Z"
        ></path>
      </svg>
    </IconWrap>
  );
};
StudioAnalytics.displayName = 'StudioAnalytics';

export default StudioAnalytics;
